<template>
    <NuxtPage />
</template>
<script setup lang="ts">
</script>
